module.exports = __webpack_public_path__ + "static/media/success-icon.e685e8a0.png";